class MembershipUserModel {

    constructor(params) {

        if (typeof params === 'undefined' || params === null) {
            return null;
        }

        this.FirstName = params.firstName;
        this.LastName = params.lastName;
        this.Email = params.email;

        this.FullName = `${this.FirstName} ${this.LastName}`;
    }

}

export default MembershipUserModel;